import { render, staticRenderFns } from "./Hortensia.vue?vue&type=template&id=21a13711&scoped=true&"
import script from "./Hortensia.vue?vue&type=script&lang=js&"
export * from "./Hortensia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a13711",
  null
  
)

export default component.exports